import PropTypes from 'prop-types'
import { Navigate, Outlet } from 'react-router-dom'

import { isAuthenticated } from '@/resources/services/permission/auth'
import AppProvider from '@/contexts'
import RedirectRules from '@/components/business/RedirectRules'

import { OnlinePaymentProvider } from '../contexts/onlinePayment'
import PageLayout from '../components/business/PageLayout'
import Sprinklr from '../components/business/Sprinklr'

const AuthenticatedRoute = ({ children = undefined }) => {
  if (!isAuthenticated()) return <Navigate to="/login" />

  return (
    <AppProvider>
      <RedirectRules />
      <OnlinePaymentProvider>
        <PageLayout>
          <Sprinklr />
          {children ? children : <Outlet />}
        </PageLayout>
      </OnlinePaymentProvider>
    </AppProvider>
  )
}

AuthenticatedRoute.propTypes = {
  children: PropTypes.node,
}

export default AuthenticatedRoute
